import './WhoWeAre.css';
import hero from '../assets/WhoWeAre/img4.jpg';
import different from '../assets/WhoWeAre/img2.jpg';
import exist from '../assets/WhoWeAre/img3.jpg';
import img1 from '../assets/WhoWeAre/img1.jpg';
import Team from './Team';

function WhoWeAre() {

    return (
        <div className="who-wrapper">
            <div className="hero-section">
                <img src={hero} alt="Hero" className="hero-image" />
                <h2>Who we are</h2>
                
            </div>

            <div className="content-section">
                {/* First Block */}
                <div className="content-block">
                    <img src={different} alt="What makes us different" />
                    <div className="text">
                        <h3>What makes us different?</h3>
                        <p>We are a Christ-centered, Spirit-led, and community-rooted church family you are welcome to join us for any other programs Amen </p>
                    </div>
                </div>

                {/* Second Block */}
                <div className="content-block reverse">
                    <img src={exist} alt="Why we exist" />
                    <div className="text">
                        <h3>Why we exist</h3>
                        <p>We exist to glorify God by reaching the unreached, loving the broken and blessed the one who are in need to be helped by us Amen</p>
                    </div>
                </div>

                {/* Third Block */}
                <div className="content-block">
                    <img src={img1} alt="Where and where we're going" />
                    <div className="text">
                        <h3>Where and where we're going</h3>
                        <p>From small beginnings to a growing, vibrant faith community we are so blessed to all who have been helping us from the years before </p>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhoWeAre;